import { SVTextInput, SVAutocomplete } from '@/components/core';
import { FORM_FIELDS } from '@/constants/formFields';
import { Card, Typography, Grid } from '@mui/material';
import SVSubdomainInput from '../../inputs/SVSubdomainInput';
import { AdvisorOfficeType } from '@/types/companies';

const ADVISOR_OFFICE_TYPE_OPTIONS = [
  {
    label: 'Registered Investment Advisor (RIA)',
    value: AdvisorOfficeType.RIA,
  },
  {
    label: 'Independent Broker-Dealer (IBD)',
    value: AdvisorOfficeType.IBD,
  },
];

type BasicInfoSectionProps = {
  staffOptions: Array<{ label: string; value: string | number }>;
  isStaffListPending: boolean;
  generatedSubdomain: string;
};

export default function BasicInfoSection({
  staffOptions,
  isStaffListPending,
  generatedSubdomain,
}: BasicInfoSectionProps) {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Basic Info
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVTextInput name="name" {...FORM_FIELDS.COMPANY_NAME} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVAutocomplete
            name="advisorOfficeType"
            {...FORM_FIELDS.ADVISOR_OFFICE_TYPE}
            options={ADVISOR_OFFICE_TYPE_OPTIONS}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVAutocomplete
            name="relationshipManagerId"
            {...FORM_FIELDS.RELATIONSHIP_MANAGER}
            options={staffOptions}
            disabled={isStaffListPending}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVSubdomainInput
            name="alias"
            externalValue={generatedSubdomain}
            rules={{ required: true }}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
